// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price-13Eel";
var _3 = "price__text-YmGiS";
var _4 = "price__money-bhLWf";
var _5 = "selectedFare__priceWrapper-1e7aW";
export { _1 as "__esModule", _2 as "price", _3 as "price__text", _4 as "price__money", _5 as "selectedFare__priceWrapper" }
export default { "__esModule": _1, "price": _2, "price__text": _3, "price__money": _4, "selectedFare__priceWrapper": _5 }
